export var MAPBOX_TOKEN = process.env.MIX_MAPBOX_TOKEN || ''; // The variance in when the function on the scroll listener will fire

export var SCROLL_DEBOUNCE = 100; // The variance in when the function on the resize listener will fire

export var RESIZE_DEBOUNCE = 100; // use for screenCategory() in library.js

export var SCREEN_SIZES = {
  mobile: {
    title: 'mobile',
    width: 320
  },
  tablet: {
    title: 'tablet',
    width: 680
  },
  desktop: {
    title: 'desktop',
    width: 1000
  }
};